import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Profesora Mariana Gómez',
  location: 'Córdoba',
  text: 'Me ahorra una cantidad enorme de tiempo. Las diapositivas ya están listas y las actividades son mucho más dinámicas que las que usaba antes.',
  img: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Profesor Lucas Fernández',
  location: 'Buenos Aires',
  text: 'Antes pasaba noches enteras armando clases. Ahora tengo todo organizado y puedo enfocarme mucho más en enseñar.',
  img: 'https://randomuser.me/api/portraits/men/32.jpg'
}, {
  name: 'Profesora Carla Benítez',
  location: 'Rosario',
  text: 'El material está súper completo. Los trabajos prácticos y las evaluaciones me resolvieron muchísimo tiempo de planificación.',
  img: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Profesora Valeria Acosta',
  location: 'Mendoza',
  text: 'Mis clases cambiaron completamente. Los alumnos participan más y yo ya no tengo que improvisar contenidos.',
  img: 'https://randomuser.me/api/portraits/women/22.jpg'
}, {
  name: 'Profesora Silvia Martínez',
  location: 'Salta',
  text: 'Una inversión excelente. La calidad de los mapas y recursos visuales es de primer nivel. Mis alumnos lo notaron enseguida.',
  img: 'https://randomuser.me/api/portraits/women/55.jpg'
}, {
  name: 'Profesora Andrea López',
  location: 'Neuquén',
  text: 'Lo que más valoro son las planificaciones ya armadas. Me sacó un peso enorme de encima para presentar en la escuela.',
  img: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Profesora Romina Castro',
  location: 'Tucumán',
  text: 'Doy clases en 4 escuelas distintas y esto me salvó la vida. Entro al aula, abro el material y ya sé exactamente qué dar.',
  img: 'https://randomuser.me/api/portraits/women/12.jpg'
}, {
  name: 'Profesor Martín Herrera',
  location: 'Santa Fe',
  text: 'No es solo teoría, las actividades son realmente didácticas y pensadas para los chicos de hoy. Lo recomiendo 100%.',
  img: 'https://randomuser.me/api/portraits/men/46.jpg'
}];
export function Testimonials() {
  return <section className="py-16 px-4 bg-white" data-id="element-142">
      <div className="max-w-6xl mx-auto" data-id="element-143">
        <div className="text-center mb-12" data-id="element-144">
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-4 uppercase" data-id="element-145">
            💬 LO QUE DICEN OTROS <span className="text-sky-600" data-id="element-146">DOCENTES</span>
          </h2>
          <p className="text-lg md:text-xl text-slate-600 font-medium" data-id="element-147">
            Docentes de todo el país ya están ahorrando horas de planificación.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-148">
          {testimonials.map((t, i) => <div key={i} className="bg-sky-50 p-6 rounded-2xl shadow-md border border-sky-100 flex flex-col h-full" data-id="element-149">
              <div className="flex items-center gap-1 text-yellow-400 mb-4" data-id="element-150">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-151" />)}
              </div>
              <p className="text-slate-700 font-medium italic mb-6 flex-grow" data-id="element-152">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-sky-200" data-id="element-153">
                <img src={t.img} alt={t.name} className="w-12 h-12 rounded-full object-cover" data-id="element-154" />
                <div data-id="element-155">
                  <p className="font-bold text-sm text-slate-900" data-id="element-156">{t.name}</p>
                  <p className="text-xs text-slate-500" data-id="element-157">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-16 text-center max-w-3xl mx-auto" data-id="element-158">
          <h3 className="text-2xl md:text-4xl font-black text-slate-900 mb-6" data-id="element-159">
            Este sistema fue creado para docentes reales, con tiempos reales y
            necesidades reales.
          </h3>
          <p className="text-2xl font-bold text-sky-600 mb-10" data-id="element-160">
            No reemplaza tu trabajo.{' '}
            <span className="text-green-600 uppercase" data-id="element-161">Lo potencia.</span>
          </p>
        </div>
      </div>
    </section>;
}